(ns practitest.frontend.import-ticket-modal.events
  (:require [ajax.core :as ajax]
            [practitest.frontend.common-entities.events :as common-events]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.common.bugtrackers :as bugtrackers]
            [practitest.frontend.components.grid.server :as server]
            [practitest.frontend.routing.backend-routes :as broutes]
            [practitest.frontend.subs :as subs]
            [re-frame.core :as re-frame]
            [practitest.frontend.components.grid :as grid]
            [practitest.frontend.impersonation :as impersonation]))

(defn toggle-import-from-bugtracker-modal
  [db [_]]
  (let [new-show? (not (get-in db [:import-modal :show-import-from-bugtracker-modal?]))]
    (re-frame/dispatch [::refresh-modal])
    (assoc-in db [:import-modal :show-import-from-bugtracker-modal?] new-show?)))

(re-frame/reg-event-fx
  ::refresh-modal
  (fn [{:keys [db]} _]
    {:db       (assoc-in db [:import-modal :local-state] {})
     :dispatch-n [[::clear-fields]
                  [::clear-notifications]]}))

(re-frame/reg-event-fx
  ::toggle-import-from-bugtracker-modal
  (fn [{:keys [db]} data]
    {:db (toggle-import-from-bugtracker-modal db data)}))

(re-frame/reg-event-db
  ::set-field-state
  (fn [db [_ field-id new-state]]
    (let [current-state (get-in db [:import-modal :fields field-id])]
      (if (map? current-state)
        (update-in db [:import-modal :fields field-id] merge new-state)
        (assoc-in db [:import-modal :fields field-id] new-state)))))

(defn got-import-modal-jira-filters [db [_ response]]
  (-> db
      (assoc-in [:import-modal :jira-filters] response)
      (update :progress disj ::fetch-import-modal-jira-filters)))

(re-frame/reg-event-fx
  ::got-import-modal-jira-filters
  (fn [{db :db} [_ response]]
    {:db       (got-import-modal-jira-filters db [nil response])
     :dispatch [::toggle-import-from-bugtracker-modal]}))

(re-frame/reg-event-fx
  ::fetch-filters-failure
  (fn [{:keys [db]} [_ response]]
    (let [authorize-url (get-in response [:response :authorize_url])]
      (if authorize-url
        {:db       (update db :progress disj ::fetch-import-modal-jira-filters)
         :dispatch [::impersonation/show
                    {:integration-name      "JIRA"
                     :authorize-url          authorize-url
                     :personal-settings-url (broutes/get-url-view "personals#index")}]}
        {:db       (update db :progress disj ::fetch-import-modal-jira-filters)
         :dispatch [:practitest.frontend.events/api-error
                    ::fetch-import-modal-jira-filters
                    {:message (get-translation "jira.import_modal.error.fetch_filters" "Error fetching Jira filters")}]}))))

(re-frame/reg-event-fx
  ::check-user-linked
  (fn [{db :db} [_ _entity-type on-linked]]
    (let [on-linked (or on-linked [::toggle-import-from-bugtracker-modal])]
      {:http-xhrio {:method          :get
                    :uri             (broutes/get-url "bugtracker_settings#check_user_linked"
                                                      {:project_id (subs/get-current-project-id db)})
                    :response-format (ajax/json-response-format {:keywords? true})
                    :on-success      [::check-user-linked-result on-linked]
                    :on-failure      [::check-user-linked-failure]}})))

(re-frame/reg-event-fx
  ::check-user-linked-failure
  (fn [_ _]
    {:dispatch [:practitest.frontend.events/api-error
                ::check-user-linked
                {:message (get-translation "bugtracker.import_modal.error.check_user_linked"
                                           "Error checking account status. Please try again.")}]}))

(re-frame/reg-event-fx
  ::check-user-linked-result
  (fn [{db :db} [_ on-linked response]]
    (let [authorize-url (or (get-in response [:response :authorize_url])
                            (:authorize_url response))
          integ-name    (bugtrackers/get-label (:integrated_bugtracker (subs/get-current-project db)))]
      (if authorize-url
        {:dispatch [::impersonation/show
                    {:integration-name      integ-name
                     :authorize-url          authorize-url
                     :personal-settings-url (broutes/get-url-view "personals#index")}]}
        {:dispatch on-linked}))))

(defn fetch-import-modal-jira-filters [{db :db} [_ entity-type]]
  (let [uri (broutes/get-url "integration_setting_jira_two_ways#get_jira_all_filters"
                             {:project_id (subs/get-current-project-id db)
                              :id         (subs/get-current-integration-id db)})
        params {:entity entity-type}]
    {:db (update db :progress conj ::fetch-import-modal-jira-filters)
     :http-xhrio
     {:method          :get
      :uri             uri
      :params          params
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::got-import-modal-jira-filters]
      :on-failure      [::fetch-filters-failure]
      }}))

(re-frame/reg-event-fx
  ::fetch-import-modal-jira-filters
  fetch-import-modal-jira-filters)

(defn jira-filter-auto-import-finished [db [_ entity-type response]]
  (-> db
      (update :progress disj ::jira-filter-auto-import)))

(re-frame/reg-event-db
  ::jira-filter-auto-import-finished
  jira-filter-auto-import-finished)

(defn jira-filter-auto-import [{db :db} [_ entity-type filter-to-import]]
  (let [url-name "integration_setting_jira_two_ways#update_sync_jira_filters_from_import_modal"
        uri (broutes/get-url url-name
                             {:project_id (subs/get-current-project-id db)
                              :id   (subs/get-current-integration-id db)})
        params {:jira_filter_id filter-to-import
                :entity entity-type}]
    {:db (update db :progress conj ::jira-filter-auto-import)
     :http-xhrio
     {:method          :post
      :uri            uri
      :format          (ajax/json-request-format)
      :vec-strategy    :rails
      :params          params
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::jira-filter-auto-import-finished entity-type]
      :on-failure      [:practitest.frontend.events/api-error
                        ::jira-filter-auto-import
                        {:message (get-translation "jira.import_modal.error.auto_import" "Error while setting filter auto import")}]
      }}))

(re-frame/reg-event-fx
  ::jira-filter-auto-import
  jira-filter-auto-import)

(re-frame/reg-event-db
  ::clear-notifications
  (fn [db _]
    (assoc-in db [:import-modal :import-modal-notifications] [])))

(re-frame/reg-event-db
  ::clear-fields
  (fn [db _]
    (assoc-in db [:import-modal :fields] nil)))

(defn import-tickets-finished [db [_ entity-type grid-state filter-to-import filter-auto-import response]]
  (when filter-auto-import
    (re-frame/dispatch [::jira-filter-auto-import entity-type filter-to-import]))
  (when (not-empty (get-in response [:import_results :saved]))
    (let [state-key (get subs/index-grid-keys entity-type)
          grid-query (server/build-query {:local-state-updating grid-state} 1)]
      (re-frame/dispatch [::common-events/fetch-entity-list entity-type state-key grid-query])))
  (-> db
      (assoc-in [:import-modal :import-modal-notifications] response)
      (update :progress disj ::import-tickets)))

(re-frame/reg-event-db
  ::import-tickets-finished
  import-tickets-finished)

(defn import-tickets [{db :db} [_ grid-state [uri params]]]
  (let [{:keys [entity-type]} params
        jira_filter_id (:jira_filter_id params)
        filter-auto-import (:filter-auto-import params)]
    {:db (update db :progress conj ::import-tickets)
     :http-xhrio
     {:method          :post
      :uri             uri
      :format          (ajax/json-request-format)
      :vec-strategy    :rails
      :params          params
      :response-format (ajax/json-response-format {:keywords? true})
      :on-success      [::import-tickets-finished entity-type grid-state jira_filter_id filter-auto-import]
      :on-failure      [:practitest.frontend.events/api-error
                        ::import-tickets
                        {:message (get-translation "bugtracker.import_modal.error.import_ticket" "Error while importing tickets")}]
      }}))

(re-frame/reg-event-fx
  ::import-tickets
  import-tickets)
